import { Key, TableRecord } from '@common/types';

export const getRecordsFromDataSourceById = <R extends TableRecord>(keys: Array<Key>, records?: R[]): R[] => {
  return records?.filter((record) => keys.includes(Number(record.ID)) || keys.includes(record.key)) ?? [];
};
